<span>
  {{ ("RECEIVER_GROUP" | translate) + " " }}

  <a [routerLink]="['/teams', $safeNavigationMigration(log?.details?.targetId)]" (click)="closeDialog.emit()">
    {{ $safeNavigationMigration(log?.details?.targetName) | identityFormat : $safeNavigationMigration(log?.details?.targetId) }}
  </a>

  {{ " " + ("WAS_MODIFIED_BY" | translate) + " " }}

  @if (!log?.staffId && log?.staffName === 'Everon Admin') {
    <strong>
      Everon Admin
    </strong>
  } @else {
    <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">
      {{ $safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId) }}
    </a>
  }

</span>

<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>

<hr />
<div class="container">

  <!-- Group name -->
  @if (visibleFields | includes : 'groupName') {
    <span class="item-title">{{ "GROUP_NAME" | translate }}:</span>
    <div class="alarm-item-pair-value">
      <span class="negative-highlight line-through">
        {{ alarmUserGroupChanges.groupName?.oldValue || ('NONE' | translate) }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ alarmUserGroupChanges.groupName?.newValue || ('NONE' | translate) }}
      </span>
    </div>
  }

  <!-- Location -->
  <!-- <ng-container *ngIf="visibleFields.includes('locationId')">
  <span class="item-title">{{ "LOCATION" | translate }}:</span>
  <div class="alarm-item-pair-value">
    <span class="negative-highlight line-through">{{ alarmUserGroupChanges.locationId.oldValue || ('NONE' | translate) }}</span>
    <i class="fa-light fa-arrow-right-long fa-lg"></i>
    <span class="positive-highlight">{{ alarmUserGroupChanges.locationId.newValue || ('NONE' | translate) }}</span>
  </div>
</ng-container>   -->

<!-- Locked -->
@if (visibleFields | includes : 'locked') {
  <span class="item-title">{{ "LOCKED" | translate }}:</span>
  <div class="alarm-item-pair-value">
    <span class="negative-highlight line-through">
      {{ alarmUserGroupChanges.locked?.oldValue === true ? ('ENABLED' | translate) : ('DISABLED' | translate) }}
    </span>
    <i class="fa-light fa-arrow-right-long fa-lg"></i>
    <span class="positive-highlight">
      {{ alarmUserGroupChanges.locked?.newValue === true ? ('ENABLED' | translate) : ('DISABLED' | translate) }}
    </span>
  </div>
}


<!-- Staff Members -->
@if (visibleFields | some : 'addedStaffs' : 'removedStaffs') {
  <span class="item-title">{{ "STAFF_MEMBERS" | translate }}:</span>
  <div class="details-box">
    <!-- Added staff -->
    @if (visibleFields | includes : 'addedStaffs') {
      <span class="item-value d-flex align-items-baseline">
        {{ "ADDED" | translate }}:
        @if (alarmUserGroupChanges?.addedStaffs?.length) {
          <div class="device-list">
            @for (staff of $safeNavigationMigration(alarmUserGroupChanges?.addedStaffs) | slice:0:getVisibleStaffItems($safeNavigationMigration(alarmUserGroupChanges?.addedStaffs), $safeNavigationMigration(alarmUserGroupChanges?.removedStaffs)).visibleAdded; track staff) {
              <div
                class="positive-highlight mt-1 mb-1 ml-2 d-inline-block"
                >
                {{ staff.name }}  ({{ staff.id }})
              </div>
            }
          </div>
        }
      </span>
    }
    <!-- Removed staff -->
    @if (visibleFields | includes : 'removedStaffs') {
      <span class="item-value d-flex align-items-baseline">
        {{ "REMOVED" | translate }}:
        @if (alarmUserGroupChanges?.removedStaffs?.length) {
          <div class="device-list">
            @for (staff of $safeNavigationMigration(alarmUserGroupChanges?.removedStaffs) | slice:0:getVisibleStaffItems($safeNavigationMigration(alarmUserGroupChanges?.addedStaffs), $safeNavigationMigration(alarmUserGroupChanges?.removedStaffs)).visibleRemoved; track staff) {
              <div
                class="negative-highlight line-through mt-1 mb-1 ml-2 d-inline-block"
                >
                {{ staff.name }}  ({{ staff.id }})
              </div>
            }
          </div>
        }
      </span>
    }
    <!-- Hidden Count -->
    @if (getVisibleStaffItems($safeNavigationMigration(alarmUserGroupChanges?.addedStaffs), $safeNavigationMigration(alarmUserGroupChanges?.removedStaffs)).hiddenCount > 0) {
      <div class="mt-4"></div>
      <span class="more-count">
        +{{ getVisibleStaffItems($safeNavigationMigration(alarmUserGroupChanges?.addedStaffs), $safeNavigationMigration(alarmUserGroupChanges?.removedStaffs)).hiddenCount }} {{ "MORE" | translate }}
      </span>
    }
  </div>
}
</div>